import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getCurrentLanguage } from '../utils/translations';

/**
 * SEOHead - Gère les balises canonical et hreflang pour éviter les problèmes
 * de contenu dupliqué dans Google Search Console.
 * 
 * Problème résolu : "Page en double sans URL canonique sélectionnée par l'utilisateur"
 */
const SEOHead = () => {
  const location = useLocation();
  const currentLanguage = getCurrentLanguage();
  const baseUrl = 'https://www.ahbenin.org';

  useEffect(() => {
    const pathname = location.pathname;

    // Déterminer le chemin sans le préfixe de langue
    let pathWithoutLang = pathname;
    if (pathname.startsWith('/fr/') || pathname.startsWith('/fr')) {
      pathWithoutLang = pathname.replace(/^\/fr/, '') || '/';
    } else if (pathname.startsWith('/en/') || pathname.startsWith('/en')) {
      pathWithoutLang = pathname.replace(/^\/en/, '') || '/';
    }

    // Construire les URLs pour chaque langue
    const frUrl = `${baseUrl}/fr${pathWithoutLang === '/' ? '' : pathWithoutLang}`;
    const enUrl = `${baseUrl}/en${pathWithoutLang === '/' ? '' : pathWithoutLang}`;
    const canonicalUrl = currentLanguage === 'en' ? enUrl : frUrl;

    // --- Canonical ---
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', canonicalUrl);

    // --- Hreflang FR ---
    let hreflangFr = document.querySelector('link[hreflang="fr"]');
    if (!hreflangFr) {
      hreflangFr = document.createElement('link');
      hreflangFr.setAttribute('rel', 'alternate');
      hreflangFr.setAttribute('hreflang', 'fr');
      document.head.appendChild(hreflangFr);
    }
    hreflangFr.setAttribute('href', frUrl);

    // --- Hreflang EN ---
    let hreflangEn = document.querySelector('link[hreflang="en"]');
    if (!hreflangEn) {
      hreflangEn = document.createElement('link');
      hreflangEn.setAttribute('rel', 'alternate');
      hreflangEn.setAttribute('hreflang', 'en');
      document.head.appendChild(hreflangEn);
    }
    hreflangEn.setAttribute('href', enUrl);

    // --- x-default (pour les moteurs de recherche) ---
    let hreflangDefault = document.querySelector('link[hreflang="x-default"]');
    if (!hreflangDefault) {
      hreflangDefault = document.createElement('link');
      hreflangDefault.setAttribute('rel', 'alternate');
      hreflangDefault.setAttribute('hreflang', 'x-default');
      document.head.appendChild(hreflangDefault);
    }
    hreflangDefault.setAttribute('href', frUrl); // FR comme langue par défaut

  }, [location.pathname, currentLanguage]);

  return null; // Ce composant ne rend rien visuellement
};

export default SEOHead;
